import * as React from 'react';
import "./RadioButtons.scss";
import { SelectableOption } from '../Shared/Shared';



interface RadioButtonProps {
    disabled?:boolean 
    option:SelectableOption 
    onClick(option:SelectableOption):void
    selectedValue?:string
}



class RadioButton extends React.Component<RadioButtonProps> {
  constructor(props:RadioButtonProps) {
    super(props);
    this.onClick = this.onClick.bind(this)
  }
  onClick() { if (!this.props.disabled) {  this.props.onClick(this.props.option) }}
  render() {
    let className = "RadioButton "
    if (this.props.selectedValue === this.props.option.value) { className += " selected"}
    if (this.props.option.isDisabled) { className += " disabled"}
    return <div className={className} onClick={this.onClick}>
        <div className="indicator">
          <div className="innerDot"></div>
        </div>
        <div className="title">{this.props.option.label}</div>
    </div>
  }
}


interface RadioButtonsProps {
  className?:string
    value:string
    options:SelectableOption[]
    inline?:boolean 
    name?:string
    onOptionSelected?(option:SelectableOption, name?:string) : void; 
    onChange?(event:{target:{name?:string, value:any}}):void
}

export function RadioButtons(props:RadioButtonsProps) {
 
  const onOptionSelected = (option:SelectableOption) => {

    if (props.onOptionSelected) {
      props.onOptionSelected(option, props.name);
    }
    if (props.onChange) {
      props.onChange({target:{name:props.name, value:option.value}});
    }
  }
  
    let className = "RadioButtons";
    if (props.className) { className += " " + props.className; }
    if (props.inline) { className += " inline"; }

    
    var options = [];
    if (props.options) {
      for (var i = 0; i < props.options.length; i++) {
        options.push (<RadioButton key={props.options[i].value} option={props.options[i]} selectedValue={props.value} onClick={onOptionSelected} />);
      }
    }
    return <div className={className}>
              {options}
            </div>
   
};
